import * as React from 'react';
import { useSelector } from 'react-redux';
import { Button, Chips, IconArrowLeft16 } from '@cian/ui-kit';
import { FormCardFooterLayout } from '../../../components/RequestFormV2/FormCardFooterLayout';
import { FormCardLayout } from '../../../components/RequestFormV2/FormCardLayout';
import { useAppDispatch } from '../../../hooks/useAppDispatch';
import { selectFlightEnabled } from '../../../selectors/meta';
import { selectQuizItemByType } from '../../../selectors/quizItems';
import { selectFormAdditionalServices } from '../../../selectors/requestFormV2/selectFormAdditionalServices';
import { setAdditionalServices, setFormStep } from '../../../slices/requestFormV2/requestFormV2Slice';
import { TAdditionalServicesValue } from '../../../types/quiz';
import { EFormStep } from '../../../types/requestForm/requestFormV2';
import { useQuizAnalytics } from '../utils/useQuizAnalytics';

export const QuizAdditionalServicesContainer = (): React.JSX.Element | null => {
  const dispatch = useAppDispatch();
  const quizItem = useSelector(selectQuizItemByType('additionalServices'));
  const additionalServicesValue = useSelector(selectFormAdditionalServices);
  const trackQuizAnalytics = useQuizAnalytics();
  const isFlightEnabled = useSelector(selectFlightEnabled);

  const handleChange = (value: TAdditionalServicesValue[]) => {
    dispatch(setAdditionalServices(value[0]));
  };

  const handleNext = () => {
    trackQuizAnalytics();
    dispatch(setFormStep(EFormStep.Contacts));
  };

  const handleBack = () => {
    dispatch(setFormStep(EFormStep.Prices));
  };

  if (!quizItem) {
    return null;
  }

  return (
    <FormCardLayout
      dataTestId="RequestFormV2Services"
      question={quizItem.title}
      image={quizItem.image}
      imageMobile={quizItem.imageMobile}
      legend={isFlightEnabled ? 'Шаг 3 из 4' : undefined}
    >
      <>
        <Chips
          selectType="single"
          value={additionalServicesValue ? [additionalServicesValue] : undefined}
          onChange={handleChange}
          options={quizItem.options.map(option => ({
            value: option.value,
            label: option.text,
            dataTestId: 'QuizFormChipOption',
          }))}
        />
        <FormCardFooterLayout>
          <Button
            size="M"
            onClick={handleBack}
            theme="stroke_secondary"
            beforeIcon={<IconArrowLeft16 color="icon-primary-default" />}
          />
          {additionalServicesValue && (
            <Button size="M" onClick={handleNext} theme="fill_primary">
              Дальше
            </Button>
          )}
        </FormCardFooterLayout>
      </>
    </FormCardLayout>
  );
};
